module.exports = __webpack_public_path__ + "img/img_dmain5.0b1b18f1.jpg";